import { camelToSnakeKeys } from '@convenia/helpers'
import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { PERSONAL_AREA } from '../consts'
import { mapFiles } from './upload'

export const mapBankAccount = (data = {}, params) => ({
  ...data,
  bankId: data?.bank?.id,
  accountDigit: data?.digit,
  accountType: data?.accountType?.id,
  files: mapFiles(data?.documentFiles || [], params)
})

export const mapBankAccountInput = ({ entityId, schema, data, invalidFields = [] } = {}) => {
  const body = {
    ...camelToSnakeKeys({
      ...(!invalidFields.includes('bank') ? { bankId: data?.bankId ? +data.bankId : '' } : {}),
      ...(!invalidFields.includes('agency') ? { agency: data?.agency } : {}),
      ...(!invalidFields.includes('account') ? { account: data?.account } : {}),
      ...(!invalidFields.includes('accountDigit') ? { digit: data?.accountDigit } : {}),
      ...(!invalidFields.includes('accountType') ? { accountTypeId: data?.accountType } : {}),
      ...(!invalidFields.includes('modality') ? { modality: data?.modality } : {}),
      ...(!invalidFields.includes('pix') ? { pix: data?.pix } : {}),
    }),
    custom_fields: mapCustomFieldValues({
      data,
      schema,
      entityId,
      sectionId: PERSONAL_AREA.BANK_ACCOUNTS,
    })
  }

  return body
}
